import {Injectable, signal, WritableSignal} from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  public sidebarScrollbarRef: NgScrollbar;

  public overlayScrollbarRef: NgScrollbar;

  private _isOverlayOpen: boolean = false;

  private _sidebarMode = signal<'shrink' | 'normal' | null>(null);

  public get sidebarMode(): WritableSignal<'shrink' | 'normal' | null> {
    return this._sidebarMode;
  }

  public set sidebarMode(value: 'shrink' | 'normal') {
    this._sidebarMode.set(value);
    localStorage.setItem('sidebarMode', value);
  }

  public isSidebarHover: boolean = false;

  get isShrink() {
    // <= 650 - режим телефона
    if (window.innerWidth <= 650) return false;
    return window.innerWidth <= 1024 || this.sidebarMode() === 'shrink' && !this.isSidebarHover;
  }

  get isShrinkFixed() {
    return this.sidebarMode() === 'shrink';
  }

  get isOverlayOpen() {
    return this._isOverlayOpen && window.innerWidth <= 650;
  }

  public readonly scrollEvents = new Subject<Event>();

  constructor() {
    this.restoreSidebarMode();
  }

  restoreSidebarMode() {
    const sidebarModeRaw = localStorage.getItem('sidebarMode');
    this.sidebarMode = sidebarModeRaw === 'shrink' ? 'shrink' : 'normal';
  }

  toggleExpander() {
    this.sidebarMode = this.sidebarMode() === 'shrink' ? 'normal' : 'shrink';
    if (this.sidebarMode() === 'shrink') {
      // Форсированно закрываем меню
      this.isSidebarHover = false;
    }
  }

  toggleOverlayOpen() {
    this._isOverlayOpen = !this._isOverlayOpen;
    if (this._isOverlayOpen) {
      setTimeout(() => {
        this.overlayScrollbarRef.update();
      });
    }
  }

  closeOverlay() {
    this._isOverlayOpen = false;
  }
}
